export const getIsRecognizedHeaderPredicate = (header: string) => (recHeading: string) =>
  header.toLowerCase().includes(recHeading);

export const recognizedSalesPriceHeadings = ['salesprice', 'sales-price', 'sales price'];
